

exports.__esModule = true;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _squid = require('squid');

var _util = require('../../fi-contingency-list/util');

var _index = require('xo-models/src/fi/index');

var _index2 = require('components/xo-models/src/checkout/index');

require('xo-ui-components/src/spinner-button/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var VERIFICATION_CODE_COUNTDOWN_IN_SECS = 180; // 3 minutes
var RESEND_CODE_LINK_TIMEOUT_MILLI_SECS = 60000; // 1 minute
var ONE_MINUTE_IN_SECS = 60;

exports['default'] = _squid.$Component.extend('$xoConfirmOtpDirective', {
    tag: 'xo-confirm-otp',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        },
        phone: {
            type: 'var',
            required: false
        },
        cardmodel: {
            type: 'var',
            required: true
        },
        onSuccess: {
            type: 'var',
            required: true
        },
        message: {
            type: 'var',
            required: true
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve()
            };
        }
    },
    actions: {
        addMessage: function addMessage(type, contentKey) {
            if (contentKey) {
                this.message({
                    msgKeys: [_angular2['default'].isArray(contentKey) ? contentKey[0] : contentKey],
                    type: type || 'error'
                });
            }
        },
        stopConfirmCodeTimer: function stopConfirmCodeTimer() {
            if (this.confirmCodeTimer) {
                _angular.$interval.cancel(this.confirmCodeTimer);
            }
            this.countdown = 0;
        },
        stopResendCodeTimer: function stopResendCodeTimer() {
            if (this.resendCodeTimer) {
                _angular.$timeout.cancel(this.resendCodeTimer);
            }
            this.showResendLink = false;
        },
        updateCountdown: function updateCountdown() {
            if (this.countdown > 0) {
                this.countdown--;
                this.timer = Math.floor(this.countdown / ONE_MINUTE_IN_SECS) + ':' + ('0' + this.countdown % ONE_MINUTE_IN_SECS).slice(-2);
            } else {
                if (!this.isConfirmProcessing) {
                    this.actions.addMessage('warning', 'confirmUpop.codeExpired');
                }
                this.actions.stopConfirmCodeTimer();
                this.actions.stopResendCodeTimer();
            }
        },
        startCountdown: function startCountdown(resetTimer) {
            var _this = this;

            if (resetTimer) {
                this.actions.stopConfirmCodeTimer();
                this.countdown = VERIFICATION_CODE_COUNTDOWN_IN_SECS;
                this.actions.updateCountdown();
                this.confirmCodeTimer = (0, _angular.$interval)(this.actions.updateCountdown, 1000);
            }

            this.actions.stopResendCodeTimer();
            this.showResendLink = false;
            this.resendCodeTimer = (0, _angular.$timeout)(function () {
                _this.showResendLink = true;
            }, RESEND_CODE_LINK_TIMEOUT_MILLI_SECS);
            this.actions.addMessage('success', 'confirmUpop.codeSent');
        },
        processed: function processed() {
            if (!this.countdown && this.isConfirmProcessing) {
                this.actions.addMessage('warning', 'confirmUpop.codeExpired');
            }
            this.isProcessing = this.isConfirmProcessing = false;
        },
        handleContingencies: function handleContingencies() {
            var result = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
            var prop = arguments[1];

            var errorData = void 0;
            if (result.errorCodes) {
                errorData = result;
            } else {
                errorData = {
                    errorCodes: [result['0'] || 'ISSUER_DECLINE']
                };
            }

            this.message(_util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error'));

            if (window.scrollTo) {
                window.scrollTo(0, 0);
            }
        },
        sendNewCode: function sendNewCode() {
            // reset the code field.
            if (this.cardmodel && this.cardmodel.card) {
                this.cardmodel.card.otp_code = '';
            }
            this.actions.resendCode(true);
        },
        resendCode: function resendCode(resetTimer) {
            var _this2 = this;

            this.isProcessing = true;

            this.resolveOTP.action('init', {
                silent: true,
                data: {
                    phone: {
                        country_code: this.phone.IntDialingCountryCode,
                        number: this.phone.telephone
                    }
                },
                resultModel: {},
                success: function success() {
                    _this2.actions.startCountdown(resetTimer);
                },

                error: function error() {
                    _this2.actions.handleContingencies();
                },

                contingencies: {
                    INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
                        // prop for last 4 digits of card in error message
                        var prop = {
                            number: _this2.cardLast4
                        };

                        _this2.actions.handleContingencies(result, prop);
                        _util.$fiErrorUtil.addFieldErrors(result, _this2.$element);
                    },
                    DEFAULT: function DEFAULT() {
                        _this2.actions.handleContingencies();
                    }
                }
            })['finally'](this.actions.processed);
        },
        confirmOTP: function confirmOTP() {
            var _this3 = this;

            this.isProcessing = this.isConfirmProcessing = true;

            this.resolveOTP.action('complete', {
                silent: true,
                data: {
                    code: this.cardmodel.card.otp_code,
                    phone: {
                        country_code: this.phone.IntDialingCountryCode,
                        number: this.phone.telephone
                    },
                    card_data: {
                        expiration_time: {
                            month: this.cardmodel.card.expiry_month,
                            year: this.cardmodel.card.expiry_year
                        },
                        card_verification_code: this.cardmodel.card.security_code
                    }
                },

                success: this.onSuccess,

                error: function error() {
                    _this3.actions.handleContingencies({}, 'confirmUpop');
                    _this3.actions.processed();
                },

                contingencies: {
                    COMPLETE_OTP_CONTINGENCY: function COMPLETE_OTP_CONTINGENCY(name, result) {
                        // prop for last 4 digits of card in error message
                        var prop = {
                            number: _this3.cardLast4
                        };

                        _this3.actions.handleContingencies(result, prop);
                        _util.$fiErrorUtil.addFieldErrors(result, _this3.$element);
                        _this3.actions.processed();
                    }
                }
            })['catch'](function () {
                _this3.actions.handleContingencies();
                _this3.actions.processed();
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this4 = this;

            this.resolveOTP = new _index.$ResolveOTP({ id: this.cardmodel.id });
            this.isProcessing = this.showResendLink = false;
            this.cardLast4 = this.cardmodel.card.number.slice(-4);
            this.phoneLast4 = this.phone && this.phone.telephone && this.phone.telephone.slice(-4);
            this.actions.startCountdown(true);

            this.$watch('isProcessing', function (isProcessing) {
                if (isProcessing) {
                    _this4.$element.addClass('processing');
                } else {
                    _this4.$element.removeClass('processing');
                }
            });
            $('#upopConfirmation .modalContainer').focus();
        }
    }
});


_angular.$interval;

_angular.$timeout;

_squid.$Component;

_util.$fiErrorUtil;

_index.$ResolveOTP;

_index2.$CheckoutSessionModel;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/confirm-upop/confirm/directive.js
 ** module id = 238
 ** module chunks = 1
 **/